import { MAP_SETTINGS_READY_SET } from './mapSettingsReady.actionTypes';

export const mapSettingsReadySet = (isReady: boolean) => ({
  type: MAP_SETTINGS_READY_SET,
  payload: {
    isReady,
  },
}) as const;
